export default __webpack_public_path__ + "static/media/klaytn.6ccf857a.svg";